<template>
    <div>
        <template v-if="mode === 'big'">
            <div>
                <textarea
                    rows="1"
                    v-validate="'required'"
                    :name="`comment_text_${ commentKey }`"
                    class="comment_textarea"
                    :placeholder="$t('enter_your_comment')"
                    @input="resize()"
                    :ref="`comment_text_${ commentKey }`"
                    v-model="text"
                    :style="inputStyle">
                </textarea>
            </div>
            <vs-button
                @click="addHandler()"
                :class="`mt-4 comment_btn comment_btn_${ commentKey }`"
                color="primary"
                type="filled">
                    {{$t('add_comment')}}
            </vs-button>
        </template>
        <template v-else>
            <div class="flex">
                <div class="w-full pr-2">
                    <textarea
                        rows="1"
                        v-validate="'required'"
                        :name="`comment_text_${ commentKey }`"
                        class="comment_textarea"
                        :placeholder="$t('enter_your_comment')"
                        @input="resize()"
                        :ref="`comment_text_${ commentKey }`"
                        v-model="text"
                        :style="inputStyle">
                    </textarea>
                </div>
                <vs-button
                    @click="addHandler()"
                    :class="`comment_btn comment_btn_${ commentKey }`"
                    color="primary"
                    icon-pack="feather" icon="icon-send"
                    type="filled" />
            </div>
        </template>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    props: {
        commentKey: {
            type: String,
            required: true
        },
        mode: {
            type: String,
            default: 'big'
        },
        type: {
            type: String,
            default: 'main_list'
        },
        parentElem: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            text: '',
            inputHeight: '38',
        }
    },
    computed: {
        inputStyle () {
            // чекамем высоту инпута
            return {
                'min-height': this.inputHeight
            }
        }
    },
    methods: {
        ...mapActions({
            addComment: 'comment/addComment'
        }),
        clearForm() {
            // Очищаем форму
            this.text = ''
            this.inputHeight = '38'
            this.resize()
            this.$validator.reset()
        },
        resize () {
            // Меняем размер инпута
            const h = this.$refs[`comment_text_${ this.commentKey }`].scrollHeight
            if(h < 38)
                this.inputHeight = '38px'
            else
                this.inputHeight = `${ h }px`
        },
        addHandler() {
            // Добавляем комментарий
            this.$validator.validateAll().then(async result => {
                if(result) {
                    try {
                        this.$nextTick(() => {
                            this.$vs.loading({
                                container: `.comment_btn_${ this.commentKey }`,
                                scale: 0.6
                            })
                        })
                        const res = await this.addComment({comment: this.commentKey, text: this.text, type: this.type, parent: this.parentElem})
                        if(res) {
                            this.clearForm()
                        }

                        this.$vs.notify({
                            text: this.$t('comment_added'),
                            color: 'success'
                        })

                        // Перерендериваем список
                        this.$emit('loadUpdate', false)
                        this.$emit('loadUpdate', true)

                        // Скрываем форму
                        this.$emit('hideInput')

                        this.$emit('updateAnswerCount')
                    } catch(e) {
                        this.$vs.notify({
                            text: this.$t('error'),
                            color: 'danger'
                        })
                    } finally {
                        this.$vs.loading.close(`.comment_btn_${ this.commentKey } > .con-vs-loading`)
                    }
                }
            })
        },
    },
    mounted() {
        this.resize()
    }
}
</script>

<style lang="scss">
.comment_btn{
    position: relative;
    .con-vs-loading{
        position: absolute;
    }
}
</style>

<style lang="scss" scoped>
.comment_textarea{
    resize: none;
    width: 100%;
    position: relative;
    border: 1px solid rgba(0,0,0,.08);
    -webkit-box-shadow: 0 0 0 0 transparent;
    padding: 9px;
    font-family: "Montserrat", Helvetica, Arial, sans-serif;
    display: block;
    overflow: hidden;
    box-shadow: 0 0 0 0 transparent;
    border-radius: 6px;
}
</style>
